import { render, staticRenderFns } from "./report-tongue80.vue?vue&type=template&id=039d1e6f&scoped=true&"
import script from "./report-tongue80.vue?vue&type=script&lang=ts&"
export * from "./report-tongue80.vue?vue&type=script&lang=ts&"
import style0 from "./report-tongue80.vue?vue&type=style&index=0&id=039d1e6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d1e6f",
  null
  
)

export default component.exports